import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { CheckCircle } from 'lucide-react';
import { getOrder } from '../../api/orders';
import styles from './OrderConfirmationPage.module.css';

export default function OrderConfirmationPage() {
  const { id } = useParams<{ id: string }>();
  const { data } = useQuery({ queryKey: ['order', id], queryFn: () => getOrder(id!), enabled: !!id });

  const order = data?.order;

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <CheckCircle size={64} color="#2e7d32" strokeWidth={1.5} />
        <h1 className={styles.title}>Order Confirmed!</h1>
        <p className={styles.orderId}>Order #{id?.slice(0, 8).toUpperCase()}</p>
        {order && (
          <div className={styles.details}>
            <div className={styles.row}><span>Total</span><span>₹{order.total?.toLocaleString('en-IN')}</span></div>
            <div className={styles.row}><span>Status</span><span className={styles.status}>Confirmed</span></div>
            {order.shippingAddress && (
              <div className={styles.address}>
                <strong>Shipping to:</strong>
                <p>{order.shippingAddress.name}</p>
                <p>{order.shippingAddress.addressLine1}</p>
                <p>{order.shippingAddress.city}, {order.shippingAddress.state} - {order.shippingAddress.pincode}</p>
              </div>
            )}
          </div>
        )}
        <div className={styles.actions}>
          <Link to="/orders" className={styles.ordersBtn}>View All Orders</Link>
          <Link to="/catalogue" className={styles.shopBtn}>Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
